export function sortBasedOnType<T extends string | number>(a: T, b: T) {
  if (typeof a === "string" && typeof b === "string") {
    return a.localeCompare(b);
  } else if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}
